
import React from 'react';


export default function() {
  return (
    <svg version="1.1"
      width="58" height="58"
      viewBox="0 0 58 58"
      xmlns="http://www.w3.org/2000/svg"
      className="sbm-svg"
    >
      <circle cx="29" cy="29" r="29" fill="#C4C4C4" />
      <g fill="#4C606A">
        <path d="M29 9.15784C23.0474 9.15784 18.3158 13.8894 18.3158 19.842V22.8947H15.2632V42.7368H42.7369V22.8947H39.6842V19.842C39.6842 13.8894 34.9527 9.15784 29 9.15784ZM21.3684 19.842C21.3684 15.5684 24.7263 12.2105 29 12.2105C33.2737 12.2105 36.6316 15.5684 36.6316 19.842V22.8947H21.3684V19.842ZM39.6842 39.6842H18.3158V25.9473H39.6842V39.6842Z" />
        <path d="M30.5263 30.5262H27.4737V35.1052H30.5263V30.5262Z" />
      </g>
    </svg>
  );
};

